import { connect } from "react-redux";
import {
  patchEditUser,
  saveUserBeingEdited,
  cancelEditUser
} from "./actions/users";

import EditUserDialog from "./EditUserDialog";

const mapStateToProps = (state, ownProps) => {
  const id = state.modalForm.editUser.id;

  if (!id) {
    return {
      open: false,
      user: { accountName: "", email: "", role: -1, active: false }
    };
  }

  /* this is all quite drawn out because codacy complained */
  const userEntity = state.entities.users[id];
  const email = userEntity.email;
  const accountId = userEntity.account;
  const account = state.entities.accounts[accountId];
  const accountName = account && account.name;

  const user = Object.assign({}, state.modalForm.editUser, {
    email,
    accountName
  });

  return { user, open: true };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onSave: () => {
      dispatch(saveUserBeingEdited());
    },
    onChange: patch => {
      dispatch(patchEditUser(patch));
    },
    onCancel: () => {
      dispatch(cancelEditUser());
    }
  };
};

const EditUserDialogContainer = connect(mapStateToProps, mapDispatchToProps)(
  EditUserDialog
);

export default EditUserDialogContainer;



// WEBPACK FOOTER //
// ./src/EditUserDialogContainer.js